import {
  ProductListGroup,
  ProductListGroupId,
  Section,
} from "constants/modelCompareData/types";
import { starterKits } from "constants/modelCompareData/data/product-list-groups/starterKits";
import { readersAndIntercom } from "constants/modelCompareData/data/product-list-groups/readersAndIntercom";
import { controlHubs as accessHubs } from "constants/modelCompareData/data/product-list-groups/controlHubs";
import { AccessHubs } from "constants/modelCompareData/data/AccessHubs";
import { StarterKits } from "constants/modelCompareData/data/StarterKit";
import { Readers } from "constants/modelCompareData/data/Readers";

export type DoorAccessGroupId =
  | ProductListGroupId.StarterKits
  | ProductListGroupId.ControlHubs
  | ProductListGroupId.ReadersAndIntercom;

export const doorAccessTabs: Record<DoorAccessGroupId, ProductListGroup> = {
  [ProductListGroupId.StarterKits]: starterKits,
  [ProductListGroupId.ControlHubs]: accessHubs,
  [ProductListGroupId.ReadersAndIntercom]: readersAndIntercom,
};

export const doorAccessSections: Record<DoorAccessGroupId, Section> = {
  [ProductListGroupId.StarterKits]: StarterKits,
  [ProductListGroupId.ControlHubs]: AccessHubs,
  [ProductListGroupId.ReadersAndIntercom]: Readers,
};
